import _chunk from 'lodash/chunk';
import _ceil from 'lodash/ceil';
import { MOBILE_PAGE, MOBILE_SIZE } from 'constants/values/params';

export function calculatePages(page, totalPages, offset = 3) {
  if (totalPages <= 5) {
    return {
      first: 1,
      startPage: totalPages <= 1 ? 1 : 2,
      endPage: totalPages - 1,
      last: totalPages
    };
  }

  if (totalPages > 5) {
    if (page === totalPages) {
      const startPage = page - offset + 1;
      return {
        first: 1,
        startPage,
        endPage: startPage + offset - 1,
        last: page
      };
    }
    const position = (page - 2) % offset;
    const startPage = page - position;
    const finalPage = startPage + (offset - 1);
    const endPage = finalPage > totalPages - 1 ? totalPages : finalPage;
    return {
      first: 1,
      startPage,
      endPage,
      last: totalPages
    };
  }

  return null;
}

export const calculateTotalPages = (totalElements, pageSize) => {
  const totalPages = _ceil(totalElements / pageSize);
  return totalPages === 0 ? 1 : totalPages;
};

export const calculateDesktopList = (elements, size, page) => {
  const elementsBySize = _chunk(elements, size);
  const desktopList = elementsBySize[page - 1];
  return desktopList || [];
};

export const calculateMobileList = (elements, size, page) => {
  const startMobile = 0;
  const endMobile = size * page;
  const mobileList = elements.slice(startMobile, endMobile);

  return mobileList || [];
};

export const getPaginationProps = (
  elements,
  size,
  page,
  mobileSize = MOBILE_SIZE,
  mobilePage = MOBILE_PAGE,
  customTotalElements = null
) => {
  const totalElements = customTotalElements || elements.length;

  const desktopList = calculateDesktopList(elements, size, page);
  const mobileList = calculateMobileList(elements, mobileSize, mobilePage);

  return {
    list: desktopList,
    mobileList,
    allElements: elements,
    totalElements,
    totalPages: calculateTotalPages(totalElements, size),
    totalMobilePages: calculateTotalPages(totalElements, mobileSize),
    params: {
      page,
      size,
      mobilePage,
      mobileSize
    }
  };
};
